import { PHASE_PRODUCTION_BUILD } from 'next/constants';

const isBuilding = process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD;

export default isBuilding;
